import BlogArticleLayout from '../../components/BlogArticleLayout';
import BlogImage from '../../assets/blogs/How to Build a High-Converting Website in 2024-2.jpg';

export default function HighConvertingWebsites() {
  return (
    <BlogArticleLayout
      title="How We Build High-Converting Websites: Our Proven 5-Step Process"
      image={BlogImage}
      imageAlt="High converting website wireframes"
      ctaLabel="Book your free website strategy call"
    >
      <p>
        Your website isn’t just a digital brochure—it’s a conversion engine. But most businesses lose leads because
        their site is built without strategy, speed, or user experience in mind.
      </p>
      <p>
        At <strong>Anorc Inc</strong>, we take a performance-first approach to web design. Here’s our{' '}
        <strong>proven 5-step process</strong> for building websites that not only look great but also drive real
        results.
      </p>

      <h2 className="text-2xl font-semibold text-slate-900">1. Discovery</h2>
      <p>
        We start by understanding your business, goals, audience, and competitors. This step ensures your site aligns
        with what your visitors are looking for—and what drives them to act.
      </p>
      <p>
        <strong>What we cover:</strong>
      </p>
      <ul className="list-disc pl-5">
        <li>Brand identity and tone</li>
        <li>Ideal customer profiles</li>
        <li>Goals (leads, sales, signups, etc.)</li>
        <li>Competitor analysis</li>
      </ul>

      <h2 className="text-2xl font-semibold text-slate-900">2. Strategy</h2>
      <p>
        Once we understand your goals, we create a sitemap and user journey designed to maximise engagement and
        conversions.
      </p>
      <p>
        <strong>Deliverables include:</strong>
      </p>
      <ul className="list-disc pl-5">
        <li>Page structure and hierarchy</li>
        <li>Wireframes for layout planning</li>
        <li>Conversion-focused call-to-action (CTA) placements</li>
      </ul>

      <h2 className="text-2xl font-semibold text-slate-900">3. Design</h2>
      <p>
        With strategy in place, we move into UI/UX design. Your site should feel intuitive, mobile-friendly, and
        visually on-brand.
      </p>
      <p>
        <strong>Key focus areas:</strong>
      </p>
      <ul className="list-disc pl-5">
        <li>Responsive design across devices</li>
        <li>Fast-loading, clutter-free layout</li>
        <li>Consistent colour scheme and typography</li>
        <li>Trust-building elements (testimonials, reviews, badges)</li>
      </ul>

      <h2 className="text-2xl font-semibold text-slate-900">4. Development</h2>
      <p>
        Our development team brings the design to life using modern tech stacks that ensure speed, scalability, and
        security.
      </p>
      <p>
        <strong>What we implement:</strong>
      </p>
      <ul className="list-disc pl-5">
        <li>SEO-optimised code</li>
        <li>Clean front-end structure (React, Tailwind, etc.)</li>
        <li>CMS integration (if needed)</li>
        <li>Speed and performance optimisation</li>
      </ul>

      <h2 className="text-2xl font-semibold text-slate-900">5. Launch & optimisation</h2>
      <p>
        We don’t just launch and leave. After going live, we monitor key metrics, run A/B tests, and fine-tune based on
        real user behaviour.
      </p>
      <p>
        <strong>Post-launch actions:</strong>
      </p>
      <ul className="list-disc pl-5">
        <li>Performance analytics setup</li>
        <li>Conversion tracking (Google Analytics, Hotjar, etc.)</li>
        <li>Ongoing updates and CRO (Conversion Rate Optimisation)</li>
      </ul>

      <h2 className="text-2xl font-semibold text-slate-900">Final thoughts</h2>
      <p>
        A high-converting website is built with intention—from structure to design to performance. It’s not about flashy
        animations or templates. It’s about results.
      </p>
      <p>
        At <strong>Anorc Inc</strong>, we build websites that do more than look good—they work hard to grow your
        business.
      </p>
    </BlogArticleLayout>
  );
}
